import { render } from "./AsahiOrderInformation.vue?vue&type=template&id=0cf7bcae&scoped=true&ts=true"
import script from "./AsahiOrderInformation.vue?vue&type=script&lang=ts"
export * from "./AsahiOrderInformation.vue?vue&type=script&lang=ts"

import "./AsahiOrderInformation.vue?vue&type=style&index=0&id=0cf7bcae&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf7bcae"]])

export default __exports__